
import { Brain, BookOpen, Heart } from 'lucide-react'

export function PorQueElegirnosSection() {
  const features = [
    {
      title: "Enfoque Interdisciplinario",
      description: "Contamos con un equipo multidisciplinario: neuropsicólogos, terapeutas de lenguaje, ocupacionales, psicólogos infantiles, psicopedagogos, pediatras y psiquiatras para una atención completa.",
      icon: Brain,
      imageSrc: "/images/child-therapy.jpg",
      color: "neuro-red"
    },
    {
      title: "Modelo Integral",
      description: "Nuestro modelo se centra en la persona e involucra activamente a la familia, la escuela y los profesionales para un abordaje completo.",
      icon: BookOpen,
      imageSrc: "/images/team-psychologist.jpg",
      color: "neuro-yellow"
    },
    {
      title: "Atención Personalizada",
      description: "Creamos planes de intervención adaptados a las necesidades únicas de cada persona, involucrando activamente a la familia en el proceso.",
      icon: Heart,
      imageSrc: "/images/personalized-attention.jpg",
      color: "neuro-blue"
    },
    {
      title: "Experiencia Especializada",
      description: "Nuestros profesionales cuentan con amplia experiencia y formación específica en salud infantil integral, especializándose en neuropsicología, distintos enfoques terapéuticos y desarrollo infantil.",
      icon: BookOpen,
      imageSrc: "/images/team-group.jpg",
      color: "neuro-yellow"
    }
  ]

  const getColorClasses = (color: string) => {
    switch (color) {
      case 'neuro-red':
        return 'bg-neuro-red bg-opacity-20 text-neuro-red'
      case 'neuro-yellow':
        return 'bg-neuro-yellow bg-opacity-20 text-neuro-yellow'
      case 'neuro-blue':
        return 'bg-neuro-blue bg-opacity-20 text-neuro-blue'
      case 'neuro-green':
        return 'bg-neuro-green bg-opacity-20 text-neuro-green'
      default:
        return 'bg-neuro-blue bg-opacity-20 text-neuro-blue'
    }
  }

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      <div className="absolute -top-10 right-20 w-40 h-40 bg-neuro-blue opacity-15 rounded-full hidden md:block"></div>
      <div className="absolute bottom-20 left-10 w-40 h-40 bg-neuro-yellow opacity-15 rounded-full hidden md:block"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-neuro-dark-blue mb-6">
            ¿Por Qué Elegirnos?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            En Neuro Peques, bajo la dirección de la MSc. Mónica Vargas, ofrecemos atención integral con un enfoque multidisciplinario centrado en las necesidades específicas de cada persona y su familia. Nuestra meta es conseguir que tu hijo/a alcance su máximo nivel de autonomía y mejore su calidad de vida.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const IconComponent = feature.icon
            const colorClasses = getColorClasses(feature.color)
            return (
              <div key={index} className="transform transition-all duration-300 hover:-translate-y-2 h-full">
                <div className="bg-white rounded-xl shadow-lg overflow-hidden h-full flex flex-col">
                  <div className="h-48 bg-gray-200 relative flex-shrink-0">
                    <img
                      src={feature.imageSrc}
                      alt={feature.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="p-8 flex flex-col flex-grow">
                    <div className={`w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-6 flex-shrink-0 ${colorClasses}`}>
                      <IconComponent className="h-10 w-10" />
                    </div>
                    <h3 className="text-2xl font-bold text-neuro-dark-blue mb-4">{feature.title}</h3>
                    <p className="text-gray-600 text-lg leading-relaxed flex-grow">{feature.description}</p>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
